/* eslint-disable quotes */
export default {
  init() {
    if ($(".gallery_layout").length > 0) {
      $(".gallery_layout").lightGallery({
        // thumbnail: true,
        selector: ".gallery_item",
        exThumbImage: "data-exthumbimage",
        // autoplay: true,
        //                enableThumbSwipe: false,
        fullScreen: false,
        download: false,
        // captions: false,
        // lastRow: "hide",
        // rowHeight: 180,
        // margins: 5,
      });
    }
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/singleFacilities.js